import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import { MapDispatchToProps } from '~src/app/utils/ConnectUtils';
import { getSessionManagementServiceInstance } from '~src/sessionManagement/SessionManagementService';
import { enterSpace } from '~src/spacesPlatform/actions/EnterSpaceAction';
import { requestSpaceContents } from '~src/spacesPlatform/actions/RequestSpaceContentsActions';
import { SpacesSiteUrls } from '~src/spacesPlatform/components/spaceComponents/SpacesSiteUrls';
import { SiteSettingsSubspaceName, SpaceInfo, SpaceItemForNonEntitySpace } from '~src/spacesPlatform/state/SpaceInfo';

import { ConnectedSiteSettingsSpace } from './SiteSettingsSpace';

export interface SpaceInfoProviderDispatchProps {
  readonly enterSpace: (spaceInfo: SpaceInfo) => void;
  readonly requestSpaceContents: () => void;
}

export interface SiteSettingsSpaceProviderOwnProps {
  readonly urls: SpacesSiteUrls;
  readonly siteName: string;
  readonly subspaceName: SiteSettingsSubspaceName;
}

export type SiteSettingsSpaceProviderProps = SiteSettingsSpaceProviderOwnProps & SpaceInfoProviderDispatchProps;

function SiteSettingsSpaceProvider(props: SiteSettingsSpaceProviderProps) {
  React.useEffect(() => {
    const enterSpace = props.enterSpace;
    const requestSpaceContents = props.requestSpaceContents;
    const subspaceName = props.subspaceName;
    enterSpace({spaceType: 'sitesettings', subspaceName, item: SpaceItemForNonEntitySpace});
    requestSpaceContents();
  }, [props.enterSpace, props.requestSpaceContents, props.subspaceName]);

  return <ConnectedSiteSettingsSpace {...props} server={getSessionManagementServiceInstance()}/>;
}

const mapDispatchToProps: MapDispatchToProps<SpaceInfoProviderDispatchProps> = (dispatch) => bindActionCreators({
  enterSpace,
  requestSpaceContents,
}, dispatch);

export const ConnectedSiteSettingsSpaceProvider: React.ComponentClass<SiteSettingsSpaceProviderOwnProps>
  = connect(null, mapDispatchToProps)(SiteSettingsSpaceProvider);
